(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/views/pages/prolongation-page.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/views/pages/prolongation-page.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.vikinglotto=_svs.vikinglotto||{};
_svs.vikinglotto.templates=_svs.vikinglotto.templates||{};
svs.vikinglotto.templates.prolongation_page = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    return "  <div id=\"ngProlongationRegion\"></div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"numbergames")||(depth0 && lookupProperty(depth0,"numbergames"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"game-app/hammock",{"name":"numbergames","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":3,"column":16}}})) != null ? stack1 : "");
},"useData":true});
Handlebars.partials['svs-vikinglotto-prolongation_page'] = svs.vikinglotto.templates.prolongation_page;
})(svs, Handlebars);


 })(window);